exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header--background {\r\n    color: white;\r\n    font-size: .9rem;\r\n    text-align: center;\r\n    letter-spacing: .6px;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.card-header--background.liquidado, .badge-liquidado {\r\n    background-color: #FF6303;\r\n}\r\n\r\n.card-header--background.pagado, .badge-pagado {\r\n    background-color: #ffb100;\r\n}\r\n\r\n.card-header--background.planificado, .badge-planificado {\r\n    background-color: #00AFE5;\r\n}\r\n\r\n.card-header--background.completado, .badge-completado {\r\n    background-color: #00BF7D;\r\n}\r\n\r\n.badge-impo {\r\n    background-color: #004165;\r\n}\r\n\r\n.badge-expo {\r\n    background-color: #FF6303;\r\n}\r\n\r\n.link-detalle {\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/assets/css/dashboard.component.css
// module id = ../../../../../src/assets/css/dashboard.component.css
// module chunks = main